// Saga Actions
export const CONNECT_GOOGLE = 'CONNECT_GOOGLE';
export const DISCONNECT_GOOGLE = 'DISCONNECT_GOOGLE';

export const GET_LINE_ACCESS_TOKEN = 'GET_LINE_ACCESS_TOKEN';
export const CONNECT_LINE = 'CONNECT_LINE';
export const DISCONNECT_LINE = 'DISCONNECT_LINE';
